<template>
  <div class="SummaryLineChart">
    <div class="Info">
      <div v-for="item in infoItems" :key="item.id" class="Item">
        <Picture :name="item.image" />
        <VariantDisplay
          :total="item.total"
          :changed="item.changed"
          :title="item.label"
        />
      </div>
    </div>
    <LinesChart
      :height="220"
      :width="800"
      :series="series"
      :options="options"
    />
  </div>
</template>

<script>
import { Picture, VariantDisplay } from 'daas-components';
import { getAdvertisementDetail } from '@/api';
import { LinesChart } from '@/components';

const COLORS = ['#47abec', '#e84855', '#95c623'];
export default {
  name: 'SummaryLineChart',
  data() {
    return {
      series: [
        {
          name: this.$t('advertisement.visualizations'),
          data: [
            [1576108800000, 7041],
            [1576195200000, 7573],
            [1576281600000, 7058],
            [1576368000000, 6276],
            [1576454400000, 5614],
          ],
        },
        {
          name: this.$t('advertisement.actions'),
          data: [
            [1576108800000, 1803],
            [1576195200000, 1966],
            [1576281600000, 2008],
            [1576368000000, 1897],
            [1576454400000, 1504],
          ],
        },
        {
          name: this.$t('advertisement.contacts'),
          data: [
            [1576108800000, 368],
            [1576195200000, 169],
            [1576281600000, 574],
            [1576368000000, 230],
            [1576454400000, 353],
          ],
        },
      ],
    };
  },
  components: {
    LinesChart,
    Picture,
    VariantDisplay,
  },
  computed: {
    options() {
      return {
        colors: COLORS,
        stroke: {
          width: 2,
        },
        markers: {
          colors: '#fff',
          strokeColors: COLORS,
          size: 3,
        },
        xaxis: {
          type: 'datetime',
          labels: {
            style: {
              fontFamily: 'Open Sans',
              cssClass: 'SummaryLineChart__XAxis',
            },
            datetimeFormatter: {
              year: 'yyyy',
              month: 'MMM YY',
              day: 'dd MMM',
              hour: 'HH:mm',
            },
          },
          axisBorder: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          fontSize: '10px',
        },
      };
    },
    infoItems() {
      return [
        {
          changed: 0,
          id: 'target',
          image: 'target',
          label: this.$t('advertisement.visualizations'),
          total: 200,
        },
        {
          changed: 0,
          id: 'actions',
          image: 'actions',
          label: this.$t('advertisement.actions'),
          total: 200,
        },
      ];
    },
  },
  // mounted() {
  //   getAdvertisementDetail(this.$route.params.id).then(
  //           data => {
  //             console.log(data)
  //           },
  //           err => {
  //             console.log('Fetch Error: ', err);
  //           }
  //   );
  // },
};
</script>

<style lang="scss">
.SummaryLineChart {
  margin-left: 25%;
  margin-top: rem(20);
  display: grid;
  justify-content: center;
  @include basicCard();
  width: 50%;
  .Info {
    display: flex;
    .Item {
      margin-top: rem(10);
      margin-right: rem(60);
      h2 {
        font-size: rem(12);
      }
    }
  }
}
</style>
